<template>
  <div class="main_wrapper">
    <div class="left">
      <add-frames :isEdit="isEditProps" :priceStrategy="myPriceStrategy" />
    </div>

    <div class="center">
      <upload-material
        :isDuration="Number(isDuration)"
        :materialSize="materialSize"
        :planId="myPlanId"
        :isEdit="isEditProps"
        :isExistH5Audit="isExistH5Audit"
      />
    </div>

    <div class="right">
      <calendre :beginTime="beginTime" :endTime="endTime" :isEdit="isEditProps" />
    </div>
  </div>
</template>

<script>
import calendre from './calendre/calendre'
import addFrames from './addMaterialFrames'
import uploadMaterial from './uploadMaterial'
export default {
  name: 'MaterialFrames',
  components: {
    calendre,
    addFrames,
    uploadMaterial
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isDuration: {
      type: Number,
      default: 0
    },
    beginTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    planId: {
      type: String,
      default: ''
    },
    materialSize: {
      type: Object,
      default: {
        w: '1080',
        h: '1540'
      }
    },
    priceStrategy: {
      type: Number,
      default: 0
    },
    // 是否存在待审核记录（H5审核），审批中不允许编辑画面素材
    isExistH5Audit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEditProps: true,
      myPlanId: '',
      myPriceStrategy: 0
    }
  },
  watch: {
    isEdit: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.isEditProps = newVal
      },
      immediate: true
    },
    planId: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.myPlanId = newVal
      },
      immediate: true
    },
    priceStrategy: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.myPriceStrategy = newVal
      },
      immediate: true
    }
  },
  created() {
    // this._isEdit = this.isEdit
  }
}
</script>

<style lang="scss" scoped>
.main_wrapper {
  display: flex;
  width: 913px;
  /*height: 616px;*/
  height: 520px;
  margin: 0 auto 24px;
  display: flex;
  border: 1px solid rgba(233, 233, 233, 1);

  .left {
    height: 517px;
    overflow-y: hidden;
    width: 304px;
    padding: 16px;
    border-right: 1px solid rgba(233, 233, 233, 1);
    &:hover {
      overflow-y: auto;
    }
    &::-webkit-scrollbar-track-piece {
      background-color: #fff;
    }
  }
  .center {
    width: 304px;
    border-right: 1px solid rgba(233, 233, 233, 1);
  }
  .right {
    width: 305px;
    box-sizing: border-box;
  }
}
</style>
